export function replaceVariables(value, data) {
    if (data.parameters) {
        Object.keys(data.parameters).forEach((key) => {
            const replace = "%" + key.toLowerCase() + "%";
            const re = new RegExp(replace, "gi");
            value = value.replace(re, data.parameters[key]);
        });
    }
    Object.keys(data).forEach((key) => {
        const replace = "%" + key.toLowerCase() + "%";
        const re = new RegExp(replace, "gi");
        value = value.replace(re, data[key]);
    });
    return value;
}
